import { isValidMomentDate } from './OperatorValidators';
import { makeOperator } from './Operator';
import { MomentDateWithTime } from '../DisplayTypes';
export default makeOperator({
  displayType: MomentDateWithTime,
  name: 'AfterTimePointWithTime',
  values: [{
    name: 'value',
    isValid: isValidMomentDate
  }]
});